import { useCallback } from 'react';

import { Button } from '@bambi/component-library/src/components/Button/Button';
import { PencilIcon, TagIcon } from '@heroicons/react/24/outline';
import { ReloadIcon } from '@radix-ui/react-icons';

import { useAppDispatch } from 'src/app/store/hooks';
import { useUserRoles } from 'src/features/auth/useUserRoles';

import {
  setSelectedDriverProfile,
  setShowDriverProfileModal,
  setShowRestoreDriverProfileModal,
  teamSlice,
} from '../team.slice';
import { DriverProfile } from './DriverProfile';

export function DriverProfileRowActions({
  driverProfile,
}: {
  driverProfile: DriverProfile;
}) {
  const dispatch = useAppDispatch();
  const { isRestrictedSupport } = useUserRoles();

  const handleEditDriverProfile = useCallback(() => {
    if (isRestrictedSupport) return;
    dispatch(
      setSelectedDriverProfile({
        ...driverProfile,
      })
    );
    dispatch(setShowDriverProfileModal(true));
  }, [dispatch, driverProfile, isRestrictedSupport]);

  const handleRestoreDriverProfile = useCallback(() => {
    if (isRestrictedSupport) return;
    dispatch(
      setSelectedDriverProfile({
        ...driverProfile,
      })
    );
    dispatch(setShowRestoreDriverProfileModal(true));
  }, [dispatch, driverProfile, isRestrictedSupport]);

  return (
    <div
      className="flex items-center"
      data-testid={`driver-actions-${driverProfile.id}`}
    >
      {driverProfile.deleted_at ? (
        <Button
          onClick={handleRestoreDriverProfile}
          variant="ghost"
          disabled={isRestrictedSupport}
          dataTestId="restore-driver-profile-button"
          className="hover:text-mint"
        >
          <ReloadIcon className="h-5 w-5" />
        </Button>
      ) : (
        <>
          <Button
            onClick={handleEditDriverProfile}
            variant="ghost"
            disabled={isRestrictedSupport}
            dataTestId="edit-driver-profile-button"
            className="hover:text-mint"
          >
            <PencilIcon className="h-5 w-5" />
          </Button>
          <Button
            onClick={() => {
              dispatch(teamSlice.actions.onAddDriverTags(driverProfile.id));
            }}
            variant="ghost"
            disabled={isRestrictedSupport}
            dataTestId="add-driver-tag-button"
            className="hover:text-mint"
          >
            <TagIcon className="h-5 w-5" />
          </Button>
        </>
      )}
    </div>
  );
}
